import api from './api';

const managementRequest = (config = {}) => ({
  _authContext: 'management',
  ...config,
});

const normalizePaginated = (response) => ({
  data: response.data?.data || [],
  pageIndex: response.data?.pageIndex ?? 0,
  itemsPerPage: response.data?.itemsPerPage ?? 0,
  totalItems: response.data?.totalItems ?? 0,
});

export const getPlanDiscountVouchers = async ({ pageIndex = 0, itemsPerPage = 25 } = {}) => {
  const response = await api.get('/plan-discount-vouchers', managementRequest({
    params: { pageIndex, itemsPerPage },
  }));

  return normalizePaginated(response);
};

export const createPlanDiscountVoucher = async (payload) => {
  const response = await api.post('/plan-discount-vouchers', payload, managementRequest());
  return response.data;
};

export const disablePlanDiscountVoucher = async (voucherId) => {
  await api.post(`/plan-discount-vouchers/${voucherId}/disable`, null, managementRequest());
};
